"use client";
import { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Card,
  CardContent,
  Typography,
  Button,
  Avatar,
  Stack,
} from "@mui/material";
import {
  IMAGES,
  WEB_COLORS,
} from "@/lib/constants";
import Image from "next/image";
import { useTranslations } from "next-intl";
import { Height } from "@mui/icons-material";

const CardBanner = ({handleCheckCredit,customerStatus}) => {
const t = useTranslations("creditScore");
const creditScoreData = customerStatus?.data?.score;
  return (
    <Box xs={12} md={12} 
     sx={{
      mt: 1,
      ml:1,
      borderRadius: 4,
      display: "flex",
      justifyContent: "space-between",
      alignItems: "flex-end",
      backgroundColor: "#004135",
      backgroundImage: `url(${IMAGES.creditScoreHomeImage.src})`,
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover",
      backgroundPosition: "center",
      color: "#fff",

      width: {
        xs: "94%",   // mobile
        sm: "97%",   // tablet
        md: "65%",    // desktop
        lg: "65%!important",    // large screen
      },
    }}
    >
      
      <Grid sx={{ p: 0, width:"100%"}}>
        <Grid item xs={12} md={6} 
       >
          <Card sx={{ mt: 2, borderRadius: 3, display:"flex"}}
           style={{
            color:"#fff",
             display:"flex",
            justifyContent: "space-between",
            alignContent: "end",
            alignItems:"end",
            backgroundColor:"transparent",
            marginTop:"5px",
           }}>
            <CardContent 
              sx={{ color: "#fff", p:"0", paddingLeft:2
              }}
            >
              <Typography variant="h6" 
              sx={{ 
                fontSize: {
                  xs: "13px",   // mobile
                  sm: "16px",   // tablet
                  md: "20px",   // desktop
                  lg: "20px",   // large screen
                },
              }}
              >
                {creditScoreData ? t("creditscorelabelwithscore") : t("creditscorelabel")} 
                {creditScoreData && (
                 <Box
                    component="span"
                    sx={{ fontSize: "25px", paddingLeft:"5px", gap: "8px", display: "inline-flex", alignItems: "center", justifyContent:"center" }}
                  >
                    {creditScoreData}
                    <Image
                      src={IMAGES.congratsIcon}
                      alt="Congrats Icon"
                    />
                  </Box>
                )}
                </Typography>
              <Typography variant="body2" sx={{ mt: 0.5, fontWeight:"300",
                fontSize: {
                    xs: "11px",   // mobile
                    sm: "12px",   // tablet
                    md: "14px",   // desktop
                    lg: "14px",   // large screen
                  },
              }}
              >
                 {creditScoreData ? t("findoutwithscore") : t("findout")}
              </Typography>
              <Button
                variant="contained"
                sx={{
                  mt: 2,
                  backgroundColor: "#08f200 !important",
                  "&:hover": {
                    backgroundColor: "#06c900 !important",
                  },
                  color: "#004135",
                  textTransform: "none",
                  borderRadius: 0,
                  borderTopLeftRadius: 15,
                  borderTopRightRadius: 15,
                  ml:3,
                  pl:3,
                  pr:3,
                  fontSize:12,
                  lineHeight:{
                    xs:1,
                  },
                  fontSize: {
                    xs: "12px",   // mobile
                    sm: "13px",   // tablet
                    md: "14px",   // desktop
                    lg: "15px",   // large screen
                  },
                }}
                 onClick={() => handleCheckCredit()}
              >
                {t("checknow")}
            </Button>
            </CardContent>
          
           <Box
              sx={{
                width: {
                  xs: "25%",
                  sm: "15%",
                  md: "15%",
                  lg: "15%",
                },
                height: {
                  xs: "25%",
                  sm: "15%",
                  md: "15%",
                  lg: "15%",
                },
              }}
            >
              <Image
                src={IMAGES.manCheckCreditImg}
                alt="man image"
                style={{ width: "100%", height: "100%" }}
              />
            </Box>

            {/* <Image
              src={IMAGES.manCheckCreditImg}
              alt="man image"
              style={{
                width: "15%",
                height: "auto",
              }}
            /> */}
             
          </Card>
        </Grid>
      </Grid>
    </Box>
  
  );
};

export default CardBanner;
